import { isEmpty } from "lodash/fp";
import { DateTime } from "luxon";

import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import ActionRequiredChip from "@app/analytics/components/ActionRequiredChip";
import ActiveChip from "@app/analytics/components/ActiveChip";
import type { SyncState } from "@app/common/types/integrationSettingsTypes";

import { Column, Row } from "@rui/Stack";

interface LastPushStateProps {
  date?: DateTime;
  syncState?: SyncState;
}

const LastPushState = ({ date, syncState }: LastPushStateProps) => {
  if (!date || isEmpty(syncState)) return null;

  const dateTimeText = date.toLocaleString({
    ...DateTime.DATETIME_SHORT,
    year: "2-digit",
  });

  return (
    <>
      <Divider />
      <Column spacing={0.25}>
        <Typography variant="bodyPrimaryReg" color="shades.neutral.600">
          Last push attempted {dateTimeText}
        </Typography>
        <Row variant="left">
          {syncState === "succeeded" && (
            <ActiveChip label="Successful" showBackground={false} />
          )}
          {syncState === "failed" && (
            <ActionRequiredChip
              label="Error: Unable to push data to HubSpot"
              severity="error"
              showBackground={false}
            />
          )}
        </Row>
      </Column>
    </>
  );
};

export default LastPushState;
